export interface Configuration {
    AwsRegion: string;
    UserServicebaseUri: string;
    PayrollServicebaseUri: string;
    BankServicebaseUri: string;
    BillingServicebaseUri: string;
    ExpenseServicebaseUri: string;
    FinancialServicebaseUri: string;
    DeductibleTrackerServicebaseUri: string;
    HealthcareExpenseServicebaseUri: string;
    FileContributionServicebaseUri: string;
    FraudDetectionServicebaseUri: string;
    ClaimServicebaseUri: string;
    Advisor3ServicebaseUri: string;
    DrivewealthServicebaseUri: string;
    ThemeServicebaseUri: string;
    CardServicebaseUri: string;

    Region: string;
    Cognito: {
      UserPoolId: string;
      ClientId: string;
      IdentityPoolId: string;
      UserPoolDomain: string;
    };
    AdminCognito: {
      UserPoolId: string;
      ClientId: string;
      IdentityPoolId: string;
    };
    Okta: {
      ClientId: string;
      Issuer: string;
    };
    EmployerOkta: {
      ClientId: string;
      Issuer: string;
    };
    AdminOkta: {
      ClientId: string;
      Issuer: string;
    };
    Mobile: {
      PartnerId: string;
      AppId: string;
      AuthType: string;
      AppName: string;
      AppVersion: string;
      RateApp: string;
    };
    Census: {
      BucketName: string;
    };
    Expense: {
      BucketName: string;
    };
    IsTest: boolean;
    CognitoDRMode?: boolean;
    LaunchDarklyClientId: string;
}

let config: Configuration = {
  AwsRegion: "AwsRegion",
  UserServicebaseUri: "UserServicebaseUri",
  PayrollServicebaseUri: "PayrollServicebaseUri",
  BankServicebaseUri: "BankServicebaseUri",
  BillingServicebaseUri: "BillingServicebaseUri",
  ExpenseServicebaseUri: "ExpenseServicebaseUri",
  FinancialServicebaseUri: "FinancialServiebaseUri",
  Advisor3ServicebaseUri: "Advisor3ServicebaseUri",
  DeductibleTrackerServicebaseUri: "DeductibleTrackerServicebaseUri",
  HealthcareExpenseServicebaseUri: "HealthcareExpenseServicebaseUri",
  FileContributionServicebaseUri: "FileContributionServicebaseUri",
  FraudDetectionServicebaseUri: "FraudDetectionServicebaseUri",
  ClaimServicebaseUri: "ClaimServicebaseUri",
  DrivewealthServicebaseUri: "DrivewealthServicebaseUri",
  ThemeServicebaseUri: "ThemeServicebaseUri",
  CardServicebaseUri: "CardServicebaseUri",
  Region: "Region",
  Cognito: {
      UserPoolId: "UserPoolId",
      ClientId: "ClientId",
      IdentityPoolId: "IdentityPoolId",
      UserPoolDomain: "UserPoolDomain"
  },
  AdminCognito: {
      UserPoolId: "UserPoolId",
      ClientId: "ClientId",
      IdentityPoolId: "IdentityPoolId"
  },
  Okta: {
    ClientId: "ClientId",
    Issuer: "Issuer"
  },
  AdminOkta: {
    ClientId: "ClientId",
    Issuer: "Issuer"
  },
  EmployerOkta: {
    ClientId: "ClientId",
    Issuer: "Issuer"
  },
  Mobile: {
    PartnerId: "PartnerId",
    AppId: "AppId",
    AuthType: "AuthType",
    AppName: "AppName",
    AppVersion: "AppVersion",
    RateApp: "RateApp"
  },
  Census: {
      BucketName: "BucketName"
  },
  Expense: {
    BucketName: "BucketName"
  },
  IsTest: true,
  LaunchDarklyClientId: ""
};

// tslint:disable-next-line:no-string-literal
if (window["BendConfig"]) {
  // tslint:disable-next-line:no-string-literal
  config = <Configuration> window["BendConfig"];
}

export const Config = config;
